module.exports = __webpack_public_path__ + "static/media/businesslunch-catering-1.1a2b1ba1.jpg";